
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dataService } from "../../../services/data.services";


const initialState = {
    loading: true,
    error: '',
    success: '',
}
export const GroupsLedgers = createAsyncThunk('staff-list', async (searchParams) => {
    let res = await dataService.GetAPI(searchParams);
    return res
})
const GroupsLedgersSlice = createSlice({

    name: 'GroupsLedgers-list',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = true
        }

    },
    extraReducers: {
        [GroupsLedgers.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [GroupsLedgers.fulfilled]: (state, action) => {
            state.loading = false;
            if(!action?.payload?.error && action?.payload?.data.status===200){
                state.List=action?.payload?.data.data;
                
            }else{
                state.error=action?.payload?.data?.message
            }
        },
        [GroupsLedgers.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})
export const { setLoading } = GroupsLedgersSlice.actions;
export default GroupsLedgersSlice.reducer